import { render, staticRenderFns } from "./member-tab.vue?vue&type=template&id=55c9d9ec"
import script from "./member-tab.vue?vue&type=script&lang=js"
export * from "./member-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports